
const sumTimeEstimate = (sections: any[]) => Array.isArray(sections) ?
    sections.reduce((acc, section) => acc + section.timeEstimate, 0) :
    0;

const useModule = (moduleEntry: any) => {
    // Module
    const module = computed(() => {
        let moduleValue = toValue(moduleEntry);

        if (!moduleValue || !Array.isArray(moduleValue.chapters)) {
            return { ...moduleValue, chapters: [], timeEstimate: 0 };
        }

        // Calculate time estimate for each chapter
        moduleValue = {
            ...moduleValue,
            chapters: moduleValue?.chapters?.map((chapter) => ({
                ...chapter,
                timeEstimate: sumTimeEstimate(chapter.sections),
            })),
        };

        // Return with full time estimate
        return {
            ...moduleValue,
            timeEstimate: sumTimeEstimate(moduleValue?.chapters),
        };
    });


    const getTimeEstimate = (id: string) => {

        if (!module.value?.timeEstimate) {
            return 0;
        }

        // Start module
        if(module.value.id === id) {
            return module.value?.timeEstimate ?? 0;
        }

        return module.value?.chapters?.reduce((acc, chapter) => {
            // Chapter
            if(chapter.id === id) {
                return chapter?.timeEstimate ?? 0;
            }
            // Check items
            const item = chapter.sections.find((section) => section.id === id)?.timeEstimate ?? 0;
            return item || acc;
        }, null);
    };

    return {
        module,
        getTimeEstimate,
    };
};

export default useModule;
